<div
  class="fixed top-3 left-1/2 -translate-x-1/2 z-[10000] flex flex-col gap-2 items-center pointer-events-none w-[calc(100vw-1.5rem)] sm:w-auto"
  aria-live="polite"
  aria-label="Notificaciones"
>
  <div
    *ngFor="let toast of toasts; trackBy: trackById"
    [@toastState]
    class="relative pointer-events-auto flex items-start overflow-hidden rounded-2xl border border-white/30 shadow-[0_12px_40px_rgba(0,0,0,0.22),0_2px_8px_rgba(0,0,0,0.10)] backdrop-blur-xl gap-3 w-full sm:min-w-[360px] sm:max-w-[480px] pl-5 pr-3 py-3 sm:pl-6 sm:pr-4 sm:py-4"
    [ngClass]="cardBgClass(toast.variant)"
  >
    <span
      class="absolute left-0 top-4 bottom-4 w-[3px] rounded-r-full"
      [ngClass]="accentBarClass(toast.variant)"
    ></span>

    <div class="mt-0.5 flex-shrink-0" [ngSwitch]="toast.variant">
      <svg
        *ngSwitchCase="'success'"
        [ngClass]="iconClass(toast.variant)"
        class="h-5 w-5 sm:h-6 sm:w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <path d="m9 11 3 3L22 4" />
      </svg>
      <svg
        *ngSwitchCase="'destructive'"
        [ngClass]="iconClass(toast.variant)"
        class="h-5 w-5 sm:h-6 sm:w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <svg
        *ngSwitchDefault
        [ngClass]="iconClass(toast.variant)"
        class="h-5 w-5 sm:h-6 sm:w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>
    </div>

    <div class="flex-1 min-w-0">
      <p
        class="text-sm sm:text-base font-semibold leading-tight"
        [ngClass]="titleClass(toast.variant)"
      >
        {{ toast.title }}
      </p>
      <p
        *ngIf="toast.description"
        class="mt-0.5 text-xs sm:text-sm leading-snug"
        [ngClass]="descClass(toast.variant)"
      >
        {{ toast.description }}
      </p>
    </div>

    <button
      type="button"
      (click)="dismiss(toast.id)"
      class="flex-shrink-0 rounded-lg p-1 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
      [ngClass]="closeClass(toast.variant)"
      aria-label="Cerrar notificación"
    >
      <svg
        class="h-4 w-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
</div>
